module.exports = __webpack_public_path__ + "static/media/icon-videocall.3119573a.svg";